import { ApplicationState } from 'app/types-store';
import { CaseState } from 'app/area/case/types-store';
import * as caseData from 'app/area/case/case-data-model';
import { createUTCDate } from 'app/infrastructure/data/date';

export interface CommentContainerProps {  
  initialValues: {[indexer: string]: any};
}

export const commentValues = (state: CaseState, uiEngineProps: any, fullState: ApplicationState ) => {

    const currentUser = fullState.app.userInfo.id;

    return {      
      valueFormatter: (text: string) => ({
          [(caseData.columnName[caseData.tableName.comment] as any).submittedComment]: [{ value: text }],
          [(caseData.columnName[caseData.tableName.comment] as any).submittedBy]: [{ value: currentUser }],
          [(caseData.columnName[caseData.tableName.comment] as any).submittedDate]: [{value: createUTCDate()}] 
      })
    };     
};
